import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  settingsPopup: {
    position: 'fixed',
    top: 0,
    left: '-100%',
    height: '100%',
    width: '580px',
    backgroundColor: colors.primaryBackground,
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    zIndex: 100,
    transition: 'left 0.3s ease',
    transform: 'translateX(0%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  settingsPopupVisible: {
    left: '0%',
  },

  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 99,
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 0.3s ease',
  },
  overlayVisible: {
    opacity: 1,
    pointerEvents: 'all',
  },
  navigation: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '64px',
    padding: '16px 24px',
    gap: anatomy['size-8'],
    marginTop: 'auto',
  },

  headerPopupContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '28px 28px',
    fontSize: typography['fontSizeHeading-4'],
    color: colors.primaryText,

    lineHeight: typography['fontSizeHeading-2'],
    width: '100%',
  },
  closeIcon: {
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    background: 'none',
    padding: 0,
    margin: 0,
    cursor: 'pointer',
    font: 'inherit',
    color: 'inherit',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '0px 28px',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignitems: 'flex-start',
    gap: anatomy['space-20'],
    alignSelf: 'stretch',
  },
  sectionInvite: {
    display: 'flex',
    width: '524px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-20'],
  },
  sectionInviteHeader: {
    display: 'flex',
    width: '476px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-4'],
  },
  sectionInviteTitle: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-4'],
    color: colors.primaryText,
  },
  sectionInviteText: {
    color: colors.secondaryText,
    fontFamily: 'DIN 2014',
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-5'],
  },
  invitationParams: {
    display: 'flex',
    gap: anatomy['space-16'],
    width: '100%',
  },
  fieldWrapper: {
    position: 'relative',
    width: '50%',
    fontSize: typography['fontSizeCaption-2'],
    color: colors.secondaryText,
  },

  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '4px',
  },
  labelType: {
    color: palette['grey-600'],
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeCaption-2'],
  },
  labelTypeBlock: {
    color: palette['grey-500'],
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeCaption-2'],
  },
  labelIcon: {
    width: '16px',
    height: '16px',
    marginLeft: '4px',
  },
  lockedDateContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    border: `1px solid ${palette['grey-200']}`,
    borderRadius: '8px',
    height: '36px',
  },
  lockedDateContainerBlock: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    border: `1px solid ${palette['grey-100']}`,
    borderRadius: '8px',
    height: '36px',
  },
  lockedDateText: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  lockedDateTextBlock: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  calendarIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  skipTicketsRow: {
    marginTop: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-8'],
  },
  skipTicketsText: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
  },
  lockedDropdownContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    border: `1px solid ${palette['grey-200']}`,
    borderRadius: anatomy.borderRadiusS,
    height: '36px',
  },
  lockedDropdownText: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  dropdownIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  textAreaContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-4'],
    width: '100%',
  },
  textAreaLabel: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '4px',
  },
  lockedTextArea: {
    display: 'flex',
    padding: '12px',
    borderRadius: anatomy.borderRadiusS,
    border: `1px solid ${palette['grey-100']}`,
    background: palette['grey-50'],
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    minHeight: '64px',
    maxHeight: '120px',
    overflowY: 'auto',
  },
  textCount: {
    color: palette['grey-500'],
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  sectionInviteArea: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-16'],
  },
  switcherText: {
    display: 'flex',
    gap: anatomy['space-8'],
    fontSize: typography['fontSizeCaption-2'],
    alignItems: 'center',
    height: '20px',
    color: colors.primaryText,
  },
  eventDayTimeRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: anatomy['space-8'],
    // Метка Input'а позиционирована абсолютно на top: -20px и выпадает из потока,
    // поэтому gap секции её не учитывает. Компенсируем эти 20px, чтобы «Часы»
    // и «Минуты» не наезжали на строку переключателя выше.
    marginTop: anatomy['space-20'],
  },
  eventDayTimeSeparator: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeBody-1'],
    lineHeight: '36px',
  },
  eventDayTimeError: {
    color: colors.errorText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'space-between',
  },
  previewEmail: {
    marginTop: anatomy['size-4'],
    padding: anatomy['size-12'],
    borderRadius: anatomy.borderRadiusS,
    border: `1px solid ${colors.tertiaryBorder}`,
    lineHeight: typography['lineHeightCaption-1'],
    ':not(#__unused__) > div': {
      overflow: 'visible',
    },
  },
});
